import emotionBelonging from '@/assets/images/emotions/belonging.png';
import emotionEmpathy from '@/assets/images/emotions/empathy.png';
import emotionEngagement from '@/assets/images/emotions/engagement.png';
import emotionTrust from '@/assets/images/emotions/trust.png';
import emotionCelebrate from '@/assets/images/emotions/celebrate.png';
import emotionInsightful from '@/assets/images/emotions/insightful.png';
import emotionLove from '@/assets/images/emotions/love.png';
import emotionSupport from '@/assets/images/emotions/support.png';

export type Reaction = {
  src: string;
  label?: string;
  value: ReactionType;
};

export enum ReactionType {
  TRUST = 'trust',
  BELONGING = 'belonging',
  EMPATHY = 'empathy',
  ENGAGEMENT = 'engagement',
  CELEBRATE = 'celebrate',
  INSIGHTFUL = 'insightful',
  LOVE = 'love',
  SUPPORT = 'support'
}

export const numberForReactionType = (reactionType: ReactionType) => {
  switch (reactionType) {
    case ReactionType.TRUST:
      return 1;
    case ReactionType.BELONGING:
      return 2;
    case ReactionType.EMPATHY:
      return 3;
    case ReactionType.ENGAGEMENT:
      return 4;
    case ReactionType.LOVE:
      return 5;
    case ReactionType.INSIGHTFUL:
      return 6;
    case ReactionType.CELEBRATE:
      return 7;
    case ReactionType.SUPPORT:
      return 8;
    default:
      return 5;
  }
};

export const reactionTypeForNumber = (num: number) => {
  switch (num) {
    case 1:
      return ReactionType.TRUST;
    case 2:
      return ReactionType.BELONGING;
    case 3:
      return ReactionType.EMPATHY;
    case 4:
      return ReactionType.ENGAGEMENT;
    case 5:
      return ReactionType.LOVE;
    case 6:
      return ReactionType.INSIGHTFUL;
    case 7:
      return ReactionType.CELEBRATE;
    case 8:
      return ReactionType.SUPPORT;
    default:
      return ReactionType.LOVE;
  }
};

export const reactionImageForType = (reactionType: ReactionType) => {
  switch (reactionType) {
    case ReactionType.BELONGING:
      return emotionBelonging;
    case ReactionType.EMPATHY:
      return emotionEmpathy;
    case ReactionType.ENGAGEMENT:
      return emotionEngagement;
    case ReactionType.TRUST:
      return emotionTrust;
    case ReactionType.LOVE:
      return emotionLove;
    case ReactionType.INSIGHTFUL:
      return emotionInsightful;
    case ReactionType.CELEBRATE:
      return emotionCelebrate;
    case ReactionType.SUPPORT:
      return emotionSupport;
    default:
      return emotionLove;
  }
};

export const playerGameReactions: Reaction[] = [
  /*{ src: emotionTrust, value: ReactionType.TRUST, label: "That's awesome" },
  { src: emotionBelonging, value: ReactionType.BELONGING, label: 'Appreciate this' },
  { src: emotionEmpathy, value: ReactionType.EMPATHY, label: 'Feeling the same' },
  { src: emotionEngagement, value: ReactionType.ENGAGEMENT, label: 'Totally understand' },*/
  { src: emotionCelebrate, value: ReactionType.CELEBRATE, label: 'Celebrate' },
  { src: emotionInsightful, value: ReactionType.INSIGHTFUL, label: 'Insightful' },
  { src: emotionLove, value: ReactionType.LOVE, label: 'Love' },
  { src: emotionSupport, value: ReactionType.SUPPORT, label: 'Support' }
];

/*
This is not implemented
export const playerSummaryReactions: any = [
  {
    src: reactionImageForType(ReactionType.TRUST),
    label: 'Trust Badge',
    reactionValue: 1,
    description:
      'People appreciated what you shared, giving them confidence in your integrity and ability to foster a genuine connection.'
  },
  {
    src: reactionImageForType(ReactionType.BELONGING),
    label: 'Belonging Badge',
    reactionValue: 2,
    description:
      'What you shared resonated with your fellow players. They feel a sense of inclusion and may have similar emotions or experiences.'
  },
  {
    src: reactionImageForType(ReactionType.EMPATHY),
    label: 'Empathy Badge',
    reactionValue: 3,
    description:
      'People identified with what you shared, and they were able to understand your feelings, experiences, and perspectives.'
  },
  {
    src: reactionImageForType(ReactionType.ENGAGEMENT),
    label: 'Engagement Badge',
    reactionValue: 4,
    description:
      'Fellow players felt connected with you. They are emotionally invested and interested in what you shared and want to know more.'
  }
];*/

export const hostSummaryReactions = [
  /*{
    src: reactionImageForType(ReactionType.TRUST),
    reactionValue: 1,
    label: 'Trust',
    description:
      'The Trust Badge is earned by players who consistently foster respect and camaraderie throughout the game. Through acts of kindness and genuine interactions, they create a more supportive and collaborative team.'
  },
  {
    src: reactionImageForType(ReactionType.BELONGING),
    reactionValue: 2,
    label: 'Belonging',
    description:
      'The Belonging Badge is given to players who actively cultivate a sense of community, diversity, and inclusivity within the game. They ensure that every team member feels valued, respected, and connected.'
  },
  {
    src: reactionImageForType(ReactionType.EMPATHY),
    reactionValue: 3,
    label: 'Empathy',
    description:
      'The Empathy Badge recognizes players who both understand and support the emotions of others. They communicate openly, listen actively, and foster an environment of compassion and mutual respect.'
  },
  {
    src: reactionImageForType(ReactionType.ENGAGEMENT),
    reactionValue: 4,
    label: 'Engagement',
    description:
      'The Engagement Badge is achieved by players who show enthusiasm and interest in the thoughts and feelings of others. They actively contribute ideas and encourage participation both in the game and on their team.'
  },*/
  {
    src: reactionImageForType(ReactionType.LOVE),
    reactionValue: 5,
    label: 'Love',
    description: ''
  },
  {
    src: reactionImageForType(ReactionType.INSIGHTFUL),
    reactionValue: 6,
    label: 'Insightful',
    description: ''
  },
  {
    src: reactionImageForType(ReactionType.CELEBRATE),
    reactionValue: 7,
    label: 'Celebrate',
    description: '-'
  },
  {
    src: reactionImageForType(ReactionType.SUPPORT),
    reactionValue: 8,
    label: 'Support',
    description: ''
  }
];
